export default __webpack_public_path__ + "static/media/download.0b1a87a7.svg";